<!-- 購入内容確認画面のアクションボタン -->
<template>
  <section>
    <div class="actions">
      <template v-if="is0yenTicket">
        <!-- チケットを入手 -->
        <ItemButton
          label="チケットを入手"
          actionType="btn-primary"
          @clicked="goToPayment"
        />
      </template>
      <template v-else>
        <!-- 上記の内容で購入を確定するボタン -->
        <ItemButton
          label="上記の内容で決済に進む"
          actionType="btn-primary"
          @clicked="goToPayment"
        />
      </template>

      <!-- キャンセル -->
      <ItemButton
        :label="$t('common.cancelButtonLabel')"
        actionType="btn-cancel"
        @clicked="cancel"
      />

      <!-- ローディングダイアログ -->
      <DialogLoading ref="DialogLoading" :timeoutSeconds="7000" />

      <DialogPurchaseWarning
        ref="DialogPurchaseWarning"
      ></DialogPurchaseWarning>

      <DialogPurchaseFailed ref="DialogPurchaseFailed" />
      <DialogSaleLimit ref="DialogSaleLimit" :message="saleLimitErrorMessage" />
    </div>
  </section>
</template>

<script>
import { computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";
import commonService from "@/services/common";

// API
import API from "@/API";

export default {
  name: "TheBBCActions",
  props: {
    is0yenTicket: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const is0yenTicket = route.query.is_0yen_ticket == "true" ? true : false;

    const DialogPurchaseWarning = ref(null);

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const inputPaymentMethod = computed(
      () => store.getters["input/ticketing/storePaymentMethod"]
    );
    const paymentLaunchUrl = computed(
      () => store.getters["ticketing/paymentLaunchUrl"]
    );

    const DialogLoading = ref(null);

    const DialogSaleLimit = ref(null);
    const saleLimitErrorMessage = ref("");
    const DialogPurchaseFailed = ref(null);

    const goToPayment = async () => {
      try {
        //booking param
        const bookingParams = {
          book_group_id: bookGroup.value.id,
        };

        if (!is0yenTicket) {
          openPurchaseWarningDialog();

          // add more purchase params
          bookingParams.authorization_method_id = inputPaymentMethod.value.id;
          bookingParams.return_url =
            process.env.VUE_APP_SBPS_COMMON_PURCHASE_SUCCESS_URL;
          bookingParams.cancel_url =
            process.env.VUE_APP_SBPS_COMMON_PURCHASE_CANCEL_URL;
          bookingParams.error_url =
            process.env.VUE_APP_SBPS_COMMON_PURCHASE_ERROR_URL;
          bookingParams.client_type =
            process.env.VUE_APP_SBPS_COMMON_PURCHASE_CLIENT_TYPE;

          // request purchase api
          const purchaseResponse = await API.purchaseComplete(bookingParams);

          // trigger native to open external browser
          nativeHandlerService.ncOpenExternalUrl(purchaseResponse.url);

        } else {
          DialogLoading.value.openDialog();

          // request purchase api
          const purchaseResponse = await API.purchaseComplete(bookingParams);

          DialogLoading.value.closeDialog();

          // process for 0yen-ticket
          if (!purchaseResponse.url && !purchaseResponse.process_id)
          {
            // success: move to booking result screen
            router.push({
              name: "BookBookingResult",
              params: {
                id: route.params.id,
                book_group_id: store.getters["ticketing/bookGroup"].id,
              },
              query: {
                language: route.query.language,
                is_0yen_ticket: route.query.is_0yen_ticket,
              },
            });
          }
        }
      } catch (err) {
        console.log("SBPS payment ERROR:: ", err);

        DialogLoading.value.closeDialog();
        closePurchaseWarningDialog();

        // catch errors (refer booking Result)
        if (
          err.response?.data?.error == "sales_error_reservation_expired" ||
          err.response?.data?.error == "payable_error"
        ) {
          saleLimitErrorMessage.value =
            "仮予約から所定の時間が経過したため、仮予約が取り消されました。もう一度お試しください。";
          DialogSaleLimit.value.openDialog();
        } else if (err.response?.data?.error == "confirmed_error") {
          saleLimitErrorMessage.value =
            "商品の確保ができなかったため購入できません。";
          DialogSaleLimit.value.openDialog();
        } else {
          console.log("general error");
          //general error
          DialogPurchaseFailed.value.openDialog();
        }
      }
    };

    const openPurchaseWarningDialog = () => {
      DialogPurchaseWarning.value.openDialog();
    };

    const closePurchaseWarningDialog = () => {
      DialogPurchaseWarning.value.closeDialog();
    };

    const cancel = () => {
      //goto BookBookingPaymentSelection
      router.go(-1);
    };

    watchEffect(() => {
      console.log("watchEffect::paymentLaunchUrl::" + paymentLaunchUrl.value);
      if (
        paymentLaunchUrl.value != null &&
        paymentLaunchUrl.value.includes("sbps_common_purchase")
      ) {
        // get payment trigger from native
        const queryParams = commonService.getQueryParams(
          paymentLaunchUrl.value
        );
        const processId = queryParams["process_id"];

        if (paymentLaunchUrl.value.includes("result=cancel")) {
          closePurchaseWarningDialog();
          return;
        } else if (
          paymentLaunchUrl.value.includes("result=success") ||
          paymentLaunchUrl.value.includes("result=error")
        ) {
          //return_url or error_url -> move to processing page

          //move to process screen
          router.push({
            name: "BookBookingResultProcessing",
            params: {
              id: route.params.id,
              book_group_id: store.getters["ticketing/bookGroup"].id,
              process_id: processId,
            },
            query: {
              language: route.query.language,
              is_0yen_ticket: route.query.is_0yen_ticket,
            },
          });
        }
      }
    });

    return {
      DialogLoading,
      DialogPurchaseWarning,
      goToPayment,
      is0yenTicket,
      cancel,
      DialogSaleLimit,
      saleLimitErrorMessage,
      DialogPurchaseFailed,
    };
  },
};
</script>
